import { Model } from '@vuex-orm/core'
import Position from '../positions/model'

export default class Ticket extends Model {
    static get entity () {
        return 'tickets'
    }

    static fields () {
        return {
            id: this.uid(),
            title: this.string(''),
            description: this.string('').nullable(),
            timeLimit: this.number(null).nullable(),
            questionsAmount: this.number(0),
            positionId: this.uid().nullable(),
            position: this.belongsTo(Position, 'positionId'),
        }
    }
}
